import React from 'react'
import styled from 'react-emotion'
import { space, border } from '../../../style'
import { StyledButton as Button } from '../../common/Button'
import Toolbar from '../../common/Toolbar'
import Text from 'common/components/Text'
import User from 'common/components/User'
import CommentInput from '../CommentInput'

const Actions = styled('div')({
  display: 'flex',
  paddingTop: space.default,
  [`${Button}:not(:last-child)`]: {
    marginRight: space.default
  }
})

export const SigninToComment = styled(({ className, t }) => (
  <div className={className}>
    <Text>{t('discuss.comment.signin')}</Text>
    <Actions>
      <Toolbar.Spacer />
      <Button rounded to="#signin/discuss">
        {t('auth.signin')}
      </Button>
      <Button rounded to="#signup/discuss">
        {t('auth.signup')}
      </Button>
    </Actions>
  </div>
))({
  label: 'SigninToComment',
  padding: space.default
})

const CommentForm = styled(
  ({
    userId,
    text,
    setText,
    post,
    cancel,
    thread,
    autoFocus = true,
    Shortcuts,
    className,
    t
  }) => (
    <div className={className}>
      <User small userId={userId} />
      <CommentInput
        autoFocus={autoFocus}
        placeholder={t('discuss.comment.placeholder.new')}
        value={text}
        onChange={e => setText(e.target.value)}
      />
      <Actions>
        <Toolbar.Spacer />
        <Button rounded onClick={cancel}>
          {t(['discuss.comment.cancel', 'cancel'])}
        </Button>
        <Button rounded primary disabled={!text} onClick={post}>
          {thread.new ? t('discuss.comment.post') : t('discuss.comment.reply')}
        </Button>
      </Actions>
      <Shortcuts />
    </div>
  )
)({
  label: 'CommentForm',
  padding: space.default,
  '&:not(:only-child)': { borderTop: border },
  [User.className]: {
    marginBottom: space.default
  }
})

export default CommentForm
